import { Component, Input } from '@angular/core';
import { LabelType } from '../entities/label-type.entity';

@Component({
    standalone: true,
    selector: 'sh-progress-label',
    templateUrl: './progress.component.html'
})
export class ShProgressLabelComponent {
    private readonly baseClass: string = 'sh-progress-status__progress sh-progress';

    labelClass: string = this.baseClass;

    @Input()
    set type(type: LabelType | undefined) {
        this.setLabelClass(type);
    }

    @Input() percentage = 0;

    private setLabelClass(type: LabelType | undefined): void {
        switch (type) {
            case LabelType.Default:
                this.labelClass = this.baseClass;
                break;
            case LabelType.Error:
                this.labelClass = `${this.baseClass}--error`;
                break;
            case LabelType.Warning:
                this.labelClass = `${this.baseClass}--warning`;
                break;
            case LabelType.Success:
                this.labelClass = `${this.baseClass}--success`;
                break;
            case LabelType.Update:
                this.labelClass = `${this.baseClass}--update`;
                break;
            default:
                this.labelClass = `${this.baseClass}`;
                break;
        }
    }
}
